// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sa-6";
export var imgContainer = "_sa-3";
export var menuIcon = "_sa-5";
export var pillWrapper = "_sa-2";
export var pillsContainer = "_sa-1";
export var subscriptionCard = "_sa-0";
export var subscriptionLogo = "_sa-4";